import {
  ListItemButton as ListItemButtonMui,
  ListItemButtonProps as ListItemButtonPropsMui,
} from '@mui/material';

export type ListItemButtonProps = ListItemButtonPropsMui;

export function ListItemButton({ ...rest }: ListItemButtonProps) {
  return <ListItemButtonMui {...rest} />;
}
